import useCities from "../../../hooks/useCities";
import React, {useMemo, useState} from "react";
import Model, {helper} from "@tripian/model";
import {CITY_INFO} from "../../../constants/ROUTER_PATH_TITLE";
import {RSelectOption} from "../../CitySelectPage/CitySelectPage";
import { useNavigate } from "react-router-dom";
import useTranslate from "../../../hooks/useTranslate";

const FeaturedDestinations = () => {
    const { cities, loadingCities } = useCities();
    const [selectedCityId, setSelectedCityId] = useState<number>();
    const [, setSearchQuery] = useState("");
    const [showAllCities, setShowAllCities] = useState(false);
    const { t } = useTranslate();
    const navigate = useNavigate();

    const destinations: {
        destinationId: number;
        destinationName: string;
        coordinate: Model.Coordinate;
        parentName: string;
    }[] = useMemo(() => {
        if (cities) {
            return cities?.map(city => {
                return {
                    destinationId: city.id,
                    destinationName: city.name,
                    coordinate: city.coordinate,
                    parentName:
                        city.parentLocations.length === 0
                            ? city.country.name
                            : `${city.parentLocations.map(parent => parent.name).join(", ")}, ${city.country.name}`,
                };
            });
        }
        return [];
    }, [cities]);

    const destinationOptions: RSelectOption[] = useMemo(
        () =>
            destinations
                .sort((a, b) =>
                    helper.compareStringForSort(a.destinationName, b.destinationName)
                )
                .map(d => ({
                    id: d.destinationId,
                    label: `${d.destinationName} - ${d.parentName}`,
                    payload: d,
                    isSelected: d.destinationId === selectedCityId,
                })),
        [destinations, selectedCityId]
    );

    const handleCitySelection = (selectedOption: RSelectOption) => {
        setSelectedCityId(selectedOption.id);
        navigate(`${CITY_INFO.PATH}/${selectedOption.id}`);
    };

    const popularCities = cities
        ?.filter(city => city.parentLocationId === null)
        .slice(0, 10);

    const displayedCities = showAllCities
        ? popularCities
        : popularCities?.slice(0, 5);


    return (<div className="max-w-7xl mx-auto pt-12 px-4 pb-10">
        <div>
            <div className="flex items-center justify-between mb-6">
                <h2 className="text-2xl syne-fm">{t('valai.featuredDestinations')}</h2>
                <button
                    onClick={() => setShowAllCities(!showAllCities)}
                    className="text-primary-color hover:text-primary-color-600 transition-colors"
                >
                    {t('valai.viewAll')}
                </button>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-5 gap-3 md:gap-6">
                {displayedCities?.map((city, index) => (
                    <div
                        key={city.name}
                        onClick={() => navigate(`/discover/${city.id}`)}
                        className={`bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-all cursor-pointer group ${
                            (index + 1) % 5 === 0 ? 'col-span-2 md:col-span-1' : ''
                        }`}
                    >
                        <div className="relative h-48">
                            <img
                                src={city.image.url}
                                alt={city.name}
                                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                            />
                            <div
                                className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"/>
                            <div className="absolute bottom-4 left-4 text-white">
                                <h3 className="text-xl font-bold">{city.name}</h3>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
        </div>
        );
        };
        export default FeaturedDestinations;